export function trackPageView(pageName='') {
  if (typeof analytics !== 'undefined') {
    analytics.page(pageName, { title: pageName });
  }
}

export function trackEvent(eventName, data, callback = null){
  if (typeof analytics !== 'undefined') {
    analytics.track(eventName, data, {}, callback);
  } else{
    try{
      callback();
    }catch(e){}
  }
}



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/lib/eventTracking.js